<template>
  <div class="page-content">
    <el-card class="welcome-card">
      <template #header>
        <div class="card-header">
          <span>欢迎使用管理系统</span>
        </div>
      </template>
      <div class="card-body">
        <h1>后台管理系统</h1>
        <p>这是系统的首页，请从左侧菜单选择您需要的功能。</p>
        <el-button type="primary" @click="handleLogout">退出登录</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
// 引入认证工具函数
import { removeToken } from '@/utils/auth'

export default {
  name: 'IndexPage',
  methods: {
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除token
        removeToken()
        
        // 显示成功消息
        this.$message.success('退出登录成功')
        
        // 延迟重定向到登录页，确保消息能显示
        setTimeout(() => {
          try {
            if (this.$router) {
              this.$router.push('/login')
            } else {
              window.location.href = '/#/login'
            }
          } catch (error) {
            console.error('重定向失败:', error)
          }
        }, 1000)
      }).catch(() => {
        this.$message.info('已取消退出')
      })
    }
  }
}
</script>

<style scoped>
/* .page-content {
  padding: 24px
} */

.welcome-card {
  max-width: 900px;
  margin: 0 auto
}

.card-body {
  text-align: center;
  padding: 60px 40px
}
</style>